export default "__VITE_ASSET__f26a26e5__"